<script setup lang="ts">
import type { AudioBlock } from '../../../model/assessments/interfaces'

import { AppText } from '@shared/ui/typography'

import { usePreviewContentAudio } from '../../../model/assessments/preview-content.hook'

/** An audio block: a plain `<audio controls>` on `asset.url` — no custom player (§A-10). An
 *  absent or empty URL renders a labelled placeholder rather than an element that fails silently. */
defineOptions({
  name: 'PreviewContentAudio',
})

const props = defineProps<{
  block: AudioBlock
}>()

const {
  refUrl,
  refHasUrl,
} = usePreviewContentAudio(() => props.block)
</script>

<template>
  <div class="preview-content-audio">
    <audio
      v-if="refHasUrl"
      class="preview-content-audio__player"
      :src="refUrl"
      controls
    />

    <AppText
      v-else
      name="body2"
      color="slate-500"
    >
      Audio — no URL set yet.
    </AppText>
  </div>
</template>

<style scoped lang="scss" src="./PreviewContentAudio.scss" />
